import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import userReducer from "./user/userSlice";
import companyReducer from "./company/companySlice";
import moduleReducer from "./modules/moduleSlice";
import userCompanyReducer from "./company/userCompanySlice";
import lucaReducer from "./modules/lucaSlice";
import controllerReducer from "./controller/controllerSlice";
import parasutReducer from "./modules/parasutSlice";
import rapidReducer from "./modules/rapidSlice";
import datasoftReducer from "./modules/datasoftSlice";
import zenomReducer from "./modules/zenomSlice";

export default configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        company: companyReducer,
        modules: moduleReducer,
        userCompany: userCompanyReducer,
        luca: lucaReducer,
        controller: controllerReducer,
        parasut: parasutReducer,
        rapid: rapidReducer,
        datasoft: datasoftReducer,
        zenom: zenomReducer
    }
});
